// extracted by mini-css-extract-plugin
module.exports = {"error":"newsletter_error__3Tlu8","Newsletter":"newsletter_Newsletter__rUX60","NewsletterMobile":"newsletter_NewsletterMobile__1DNYe"};